/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import BaseClass from '../base/LayoutBaseAuthoring';

const ExploreContainerAuthoring = BaseClass.extend({

	init: function() {
		ExploreContainerAuthoring.inherited('init', this, arguments);
	},
	/**
	 * Called when a new item is added to the layout model.
	 * after the view is created, get the node and add it to the parent view.
	 * Select the card iff the sender is undoRedoController and the operation is add
	 * @param {Object} - layoutView the created layout module
	 * @param {String} - insertBefore id
	 * @param {Object} - payload is the event payload that contains the model to be added.
	 */
	add: function(layoutView, insertBefore, payload) {
		this.consumeView.addChildRenderMarkup(layoutView.id, layoutView.getRenderMarkup());
		const {
			value: {
				op: operation
			} = {},
			sender
		} = payload || {};
		if (operation === 'add' && sender === 'UndoRedoController') {
			this.consumeView.model.exploreVM.setDisplayedToCard(layoutView.id);
		}
	}
});

export default ExploreContainerAuthoring;



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreContainerAuthoring.js